import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsTwo', {
    title: 'Persons',
    selectDirectorForVerification: 'Please select Director whose data should be verified',
    selectDirectorAndOwnerForVerification: 'Please select 1 Director and 1 Owner whose data should be verified',
});
